import { apiRequest, API_ENDPOINTS } from '../config/api';

export interface MetamodelShape {
  keyword: string;
  baseType: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  borderRadius?: number;
  width?: number;
  height?: number;
  iconDataUrl?: string | null;
  registrySlug?: string | null;
}

export interface DiagramMetamodel {
  id: string;
  project_id: string;
  slug: string;
  name: string;
  description: string;
  default_code?: string;
  shapes: MetamodelShape[];
  gitlab_path?: string;
  sync_status?: string;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface CreateMetamodelPayload {
  slug: string;
  name: string;
  description: string;
  default_code?: string;
  shapes: MetamodelShape[];
}

export interface UpdateMetamodelPayload {
  name: string;
  description: string;
  default_code?: string;
  shapes: MetamodelShape[];
}

export const listMetamodels = (projectId: string): Promise<DiagramMetamodel[]> =>
  apiRequest(API_ENDPOINTS.metamodels.list(projectId), { method: 'GET' });

export const getMetamodel = (projectId: string, id: string): Promise<DiagramMetamodel> =>
  apiRequest(API_ENDPOINTS.metamodels.getById(projectId, id), { method: 'GET' });

export const createMetamodel = (projectId: string, body: CreateMetamodelPayload): Promise<DiagramMetamodel> =>
  apiRequest(API_ENDPOINTS.metamodels.create(projectId), { method: 'POST', body: JSON.stringify(body) });

export const updateMetamodel = (projectId: string, id: string, body: UpdateMetamodelPayload): Promise<DiagramMetamodel> =>
  apiRequest(API_ENDPOINTS.metamodels.update(projectId, id), { method: 'PUT', body: JSON.stringify(body) });

export const deleteMetamodel = (projectId: string, id: string): Promise<void> =>
  apiRequest(API_ENDPOINTS.metamodels.delete(projectId, id), { method: 'DELETE' });

export const publishMetamodel = (projectId: string, id: string): Promise<{ status: string }> =>
  apiRequest(API_ENDPOINTS.metamodels.publish(projectId, id), { method: 'POST', body: JSON.stringify({}) });

export const pullMetamodel = (projectId: string, id: string): Promise<{ status: string }> =>
  apiRequest(API_ENDPOINTS.metamodels.pull(projectId, id), { method: 'POST', body: JSON.stringify({}) });
